import { useQuery } from "@apollo/client";
import { ApplicantProfileProfessionView } from "./applicant-profile-profession-view";
import {
  Entity,
  StaffApplicantProfileProfessionViewContainerEntitiesDocument,
  StaffApplicantProfileProfessionViewContainerApplicantUserDocument,
} from "../../../../generated";
import { Empty, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { Country } from "../../../../types/country";
import { lookupCountryQuery } from './staff-components-country-query'
import { ComponentQueryLoader } from "../../../shared/component-query-loader";

interface ApplicantProfileProfessionViewContainerProps {
  applicantId: string;
};

export const ApplicantProfileProfessionViewContainer: React.FC<ApplicantProfileProfessionViewContainerProps> = ({applicantId}) => {
  const navigate = useNavigate();

  const {
    data: professionData,
    loading: professionLoading,
    error: professionError,
  } = useQuery(
    StaffApplicantProfileProfessionViewContainerApplicantUserDocument,
    {
      variables: {
        applicantUserId: applicantId,
      },
      context: {
        headers: {
          "cache-enabled": "true",
        },
      },
    }
  
  );

  const { data: countryData, error: countryError } = useQuery(lookupCountryQuery);

  // Query to get the entities data
  const {
    data: entityData,
    loading: entityLoading,
    error: entityError,
  } = useQuery(StaffApplicantProfileProfessionViewContainerEntitiesDocument,
    {
      context: {
        headers: {
          "cache-enabled": "true",
        },
      },
    }
  );

  const filteredEntityData =
    entityData?.entities?.filter(
      (entity) => entity?.isIssuingInstitution === true
    ) || [];

  const handleEditToggle = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, "/edit");
    navigate(newPath);
  };

  if (professionLoading || entityLoading) {
    return <Skeleton active />;
  }

  if (
    professionError ||
    entityError ||
    !professionData?.applicantUser?.personalInformation?.professional
  ) {
    return (
      <Empty description="There was an error loading the data. Please try again!" />
    );
  }

  if (countryError || !countryData?.countries?.eventPayload?.countries) {
    return (
      <Empty
        description={`There was an error loading the country data. Please try again! ${countryError}`}
      />
    );
  }

  const error = professionError || entityError;
  const isLoading = professionLoading || entityLoading;
  const hasData =
    professionData.applicantUser.personalInformation.professional !==
      undefined &&
    countryData?.countries?.eventPayload?.countries !== undefined;
  return (
    <ComponentQueryLoader
      error={error}
      loading={isLoading}
      hasData={hasData}
      hasDataComponent={
        <ApplicantProfileProfessionView
          professionalInformation={
            professionData.applicantUser.personalInformation.professional
          }
          onEdit={handleEditToggle}
          countryData={
            countryData?.countries?.eventPayload?.countries as Country[]
          }
          entities={filteredEntityData as Entity[]}
        />
      }
    />
  );
};
